<article class="container">
    <section class="filters">
        <app-opportunities-filters [filtersKey]="filtersKey"></app-opportunities-filters>
    </section>
    <section class="grid">
        <app-opportunities-list [filtersKey]="filtersKey" [contactId]="contactId()"></app-opportunities-list>
    </section>
</article>
